// extracted by mini-css-extract-plugin
export var infoItem = "_rp-2";
export var title = "_rp-0";
export var value = "_rp-1";